import { useState } from "react";
import { getVehicleImages } from "../../constants/vehicleImages";

function VehicleCard({ vehicle /*, onBookNow */ }) {
  const images = getVehicleImages(vehicle.model, vehicle.year) || [vehicle.image_url];
  const [current, setCurrent] = useState(0);

  const prev = (e) => {
    e.stopPropagation();
    setCurrent((i) => (i - 1 + images.length) % images.length);
  };

  const next = (e) => {
    e.stopPropagation();
    setCurrent((i) => (i + 1) % images.length);
  };

  return (
    <div className="group relative overflow-hidden rounded-3xl bg-white shadow-md ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
      <div className="relative">
        <img
          src={images[current]}
          alt={vehicle.model}
          className="w-full h-64 object-contain bg-gray-100 transition-transform duration-500 group-hover:scale-105"
          onError={(e) =>
            (e.target.src = "https://via.placeholder.com/400x250?text=No+Image")
          }
        />

        {/* Prev / Next arrows — only shown when there are multiple images */}
        {images.length > 1 && (
          <>
            <button
              onClick={prev}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full w-7 h-7 flex items-center justify-center opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity"
            >
              ‹
            </button>
            <button
              onClick={next}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full w-7 h-7 flex items-center justify-center opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity"
            >
              ›
            </button>

            {/* Dot indicators */}
            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-1">
              {images.map((_, i) => (
                <button
                  key={i}
                  onClick={(e) => { e.stopPropagation(); setCurrent(i); }}
                  className={`w-1.5 h-1.5 rounded-full transition-all ${i === current ? "bg-white scale-125" : "bg-white/50"}`}
                />
              ))}
            </div>
          </>
        )}

        <div className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-gray-700 shadow-md ring-1 ring-black/5">
          <span className="inline-block h-2 w-2 rounded-full bg-emerald-500"></span>
          {vehicle.type}
        </div>
        {vehicle.seats ? (
          <div className="absolute left-4 bottom-4 rounded-full bg-emerald-600/95 px-4 py-1 text-sm font-bold text-white shadow-lg">
            {vehicle.seats} seats
          </div>
        ) : null}
        {/* Price badge hidden temporarily — restore when pricing is re-enabled
        <div className="absolute right-4 bottom-4 rounded-full bg-blue-600/95 px-4 py-1 text-sm font-bold text-white shadow-lg">
          ${vehicle.price_per_day}/day
        </div>
        */}
      </div>
      <div className="p-5">
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
          {vehicle.model} ({vehicle.year})
        </h3>
        {/* Book Now button hidden temporarily — restore when booking is re-enabled
        <div className="mt-4">
          <button
            onClick={() => onBookNow(vehicle)}
            className="w-full rounded-xl bg-blue-600 px-4 py-2.5 text-white font-semibold shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600/40"
          >
            Book Now
          </button>
        </div>
        */}
      </div>
    </div>
  );
}

export default VehicleCard;
